export const FDA_RECALLS_QUERY_KEY_PREFIX = 'recalls-fda-enforcement';
export const FEATURED_RECALLS_QUERY_KEY = 'recalls-featured';
export const USDA_RECALLS_QUERY_KEY_PREFIX = 'recalls-usda';
export const CPSC_RECALLS_QUERY_KEY_PREFIX = 'recalls-cpsc';
export const VEHICLE_RECALLS_QUERY_KEY_PREFIX = 'recalls-vehicle';

export const USDA_RECALL_CLASSIFICATION_IDS = {
  All: 'All',
  ClassI: '10',
  ClassII: '11',
  ClassIII: '12',
  PublicHealthAlert: '554',
} as const;

export const USDA_TRANSLATION_LANGUAGE_IDS = {
  English: 'en',
} as const;
